import { CustomAttributeDefinition, Folder } from '../model/entities';
import { proxyApiAxios } from './CustomAxios';
import qs from 'qs';

class CustomAttributeDefinitionApi {
    list = async (folders: Folder[]): Promise<CustomAttributeDefinition[]> => {
        const projectIds = folders.map((f) => f.projectId);
        const folderIds = folders.map((f) => f.id);
        const response = await proxyApiAxios.get<CustomAttributeDefinition[]>('/custom-attribute-definitions', {
            params: {
                projectId: projectIds,
                folderId: folderIds,
            },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        return response.data;
    };
}

const customAttributeDefinitionApi: CustomAttributeDefinitionApi = new CustomAttributeDefinitionApi();
export default customAttributeDefinitionApi;
